import {FC} from "react";
import {useTranslation} from "react-i18next";
import {Container} from "react-bootstrap";

import {Icon, IconName} from "../../../components/Icon";

const featureKeys: IconName[] = [
	"noForget",
	"personalized",
	"reminders",
	"offices",
	"overview",
	"czech",
];

export const Features: FC = () => {
	const {t} = useTranslation();

	return (
		<section className="section section--tint" id="features">
			<Container>
				<div className="section__head">
					<h2 className="section__title">{t("features.title")}</h2>
					<p className="section__subtitle">{t("features.subtitle")}</p>
				</div>
				<div className="row g-4">
					{featureKeys.map((key) => (
						<div key={key} className="col-12 col-md-6 col-lg-4">
							<div className="feature-card">
								<span className="feature-card__icon">
									<Icon name={key} />
								</span>
								<h3 className="feature-card__title">{t(`features.items.${key}.title`)}</h3>
								<p className="feature-card__text">{t(`features.items.${key}.text`)}</p>
							</div>
						</div>
					))}
				</div>
			</Container>
		</section>
	);
};
